<template>
  <div class="collegeView">
    <div class="phone_collegeView">
      <el-row class="hidden-lg-and-up" :gutter="20" type="flex" width="auto">
        <el-col
          :md="6"
          :xs="24"
          v-for="(item, index) in resList"
          :key="index"
          style="height: 110px; width: 160px; margin-right: 10px"
          @click.native="handleClick()"
        >
          <img :src="item.imageUrl" alt="" style="width: 160px; height: auto" />
        </el-col>
      </el-row>
    </div>

    <el-row class="hidden-md-and-down view_row">
      <el-col
        v-for="(item, index) in resList"
        :key="index"
        @click.native="handleClick()"
      >
        <img :src="item.imageUrl" alt="" />
      </el-col>
    </el-row>
  </div>
</template>

<script>
  import { getFeatures } from "@/api/college"
  export default {
    name: "homeCollegeView", //首页-学院风采
    data() {
      return {
        resList: [],
        scrollInterval: null,
        scrollPosition: 0
        // largeResList:[]
      }
    },
    mounted() {},
    created() {
      this.handleQuery()
    },
    methods: {
      handleQuery() {
        getFeatures()
          .then((res) => {
            const orginalList = res.data.data
            let repeatList = []

            //重复列表到50个元素
            while (repeatList.length < 50) {
              repeatList = repeatList.concat(orginalList)
            }

            this.resList = repeatList.slice(0, 50)

            const viewRowElement = document.querySelector(".view_row")
            if (viewRowElement) {
              viewRowElement.style.width = `${320 * this.resList.length}px`
            }
          })
          .catch((err) => {})
      },
      handleClick() {
        this.$router.push({
          path: "/collegeIntro",
          query: { tab: "4" }
        })
      }
    }
  }
</script>

<style scoped>
  .collegeView {
    padding: 25px;
    padding-left: 0;
    padding-top: 0;
    margin-top: 24px;
    height: 242px;
    background: #ffffff;
    border-radius: 10px;
    box-shadow: 0px 0px 12px 0px rgba(168, 168, 168, 0.46);
    overflow: hidden;
  }
  .collegeView img {
    width: 320px;
    height: 215px;
    float: left;
    margin-left: 22px;
    margin-top: 25px;
    transform: scale(1);
    transition: transform 0.5s ease;
    cursor: pointer;
  }
  .collegeView img:hover {
    transform: scale(1.05);
    transition: transform 0.5s ease;
  }
  @keyframes slide {
    0% {
      transform: translateX(0%);
    }
    100% {
      transform: translateX(-100%);
    }
  }
  .view_row {
    width: calc(100%);
    display: flex;
  }
  .view_row:hover {
    cursor: pointer;
    animation-play-state: paused;
  }
  .view_row {
    animation: slide 120s linear infinite;
    transition: all 0.5s ease;
  }
  /* .view_row .el-col{
    float: left;
} */
  @media (max-width: 1440px) {
    .collegeView {
      box-shadow: none;
      height: auto;
      padding-right: 0;
    }
    .phone_collegeView {
      transition: transform 0.5s ease;
      width: 100%;
      overflow-y: hidden;
    }
    .phone_collegeView img {
      transition: transform 0.5s ease;
      margin: 0;
    }
    .phone_collegeView {
      padding: 0;
    }
  }
</style>
